// extracted by mini-css-extract-plugin
var _1 = "KfVYi fieldset-reset";
var _2 = "WTCYp";
export { _1 as "base", _2 as "label" }
